/** The workspace page: the empty state without a project. */
export default {
  welcome: "Welcome to Denker",
  emptyHint: "Select a project or create a new one to get started.",
} as const;
